import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

import {
  getProductNavChildren,
  getServiceNavChildren,
  PRODUCT_NAV_LABEL,
} from "@/shared/config/header.config";
import BrandLogo from "@/shared/layout/Header/BrandLogo";
import { getThemeClass, getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";
import { WHITE_LABEL_CONFIG } from "@/whiteLable";
import { App_Url_New } from "../common/static";

const companyLinks = [
  { label: "About Us", path: App_Url_New.CommonPageUrl.aboutUs },
  { label: "Terms and Conditions", path: "#" },
  { label: "Privacy Notice", path: "#" },
  { label: "Cookies Notice", path: "#" },
];

export function SiteFooter() {
  const footerClasses = getThemeComponentClasses().footer;
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`${getThemeClass(footerClasses.bgColor, "bg-theme-accent")} ${getThemeClass(footerClasses.textColor, "text-theme-text")} ${footerClasses.root}`}
    >
      <div className="mx-auto max-w-screen-xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-1">
            <BrandLogo
              imageClassName="h-12 w-auto object-contain"
              textClassName={`text-2xl font-bold ${getThemeClass(footerClasses.brandTextColor || footerClasses.textColor, "text-theme-text")}`}
            />
          </div>

          <div>
            <h4 className="mb-4 text-lg font-bold">Contacts</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span>{WHITE_LABEL_CONFIG.contact.phoneLabel}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-medium">WhatsApp</span>
              </div>
              <div>
                <div className="flex items-center gap-2 font-bold">
                  <Mail className="h-4 w-4" />
                  General enquiries
                </div>
                <p className="mt-1">{WHITE_LABEL_CONFIG.contact.generalEmail}</p>
              </div>
              <div>
                <div className="flex items-center gap-2 font-bold">
                  <Mail className="h-4 w-4" />
                  Customer service
                </div>
                <p className="mt-1">{WHITE_LABEL_CONFIG.contact.customerServiceEmail}</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-bold">{PRODUCT_NAV_LABEL}</h4>
            <ul className="space-y-2 text-sm">
              {getProductNavChildren().map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="transition-opacity hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-bold">Services</h4>
            <ul className="space-y-2 text-sm">
              {getServiceNavChildren().map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="transition-opacity hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-bold">Company</h4>
            <ul className="space-y-2 text-sm">
              {companyLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="transition-opacity hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex items-start gap-4 lg:flex-col lg:items-end">
            {["in", "f", "⦿", "♪"].map((label) => (
              <div
                key={label}
                className={`flex h-10 w-10 items-center justify-center rounded-lg font-bold ${getThemeClass(footerClasses.socialBgColor, "bg-theme-text")} ${getThemeClass(footerClasses.socialTextColor, "text-theme-accent")}`}
              >
                {label}
              </div>
            ))}
          </div>
        </div>

        <div
          className={`mt-10 border-t pt-6 ${getThemeClass(footerClasses.borderColor, "border-theme-text")}`}
        >
          <p className="mb-4 text-sm">
            © Copyright by{" "}
            <a
              href={WHITE_LABEL_CONFIG.footer.copyrightLink}
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {WHITE_LABEL_CONFIG.footer.copyrightOwner}
            </a>{" "}
            {currentYear}. All rights reserved.
          </p>
          <p className="max-w-6xl text-xs leading-relaxed">
            {WHITE_LABEL_CONFIG.footer.regulatoryText}
          </p>
        </div>
      </div>
    </footer>
  );
}
